import React, {useState, useCallback} from 'react';

let id = 0;
const TIMEOUT = 750;

const ExploreSearch = ({
    searchTerm,
    setSearchTerm,
    setSearchOptions,
    searchOptions,
    setSearchTag,
    searchTag
}) => {
    const [text, setText] = useState('');

    const onChange = useCallback((e) => {
        let i = ++id;
        let t = e.target.value;
        setTimeout(() => {
            if (id === i) {
                setSearchTerm(t);
                if (searchOptions.includes("Starred") || searchOptions.includes("Favorited")) {
                    setSearchOptions(searchOptions.filter(
                        x => x !== "Starred" && x !== "Favorited"));
                }
            }
        }, TIMEOUT);
        setText(e.target.value);
   }, [setText, setSearchTerm, searchOptions, setSearchOptions]);

    const onClickOption = useCallback((opt) => {
        if (searchOptions.indexOf(opt) == -1) {
            if (opt === "Lists" || opt === "Projects") {
                setSearchOptions([opt]);
            } else {
                setSearchOptions([opt, ...searchOptions]);
            }
        } else {
            let options = searchOptions.filter(o => o !== opt);
            console.log('setting search options = ', options);
            setSearchOptions(options);
        }
    }, [searchOptions, setSearchOptions]);

    return (
        <div className="explore-search-container">
          {searchTag ? <div onClick={() => setSearchTag(undefined)} className="search-tag">{searchTag}</div> : ''}
          <div className="heart-and-soul">
            <SearchOption
              hideText={true}
              baseClass="heart"
              selectedClass="favorited"
              onClickOption={onClickOption}
              searchOptions={searchOptions} option="Favorited"/>
            <div></div>
            <SearchOption
              baseClass="star"
              selectedClass="starred"
              onClickOption={onClickOption}
              searchOptions={searchOptions} option="Starred"/>
          </div>
          <SearchOption
            onClickOption={onClickOption}
            searchOptions={searchOptions} option="Lists"/>
          <SearchOption
            onClickOption={onClickOption}
            searchOptions={searchOptions} option="Projects"/>
          <input
            type="text"
            value={text} onChange={onChange}
            className="explore-search"
            placeholder="Type to search"/>
          <div onClick={() => {
              setSearchTerm("");
              setText("");
              setSearchTag(undefined);
          }} className="search-clear-btn">x</div>
        </div>
    );
};

const SearchOption = ({hideText, searchOptions, option, onClickOption, baseClass="search-option", selectedClass="selected"}) => {
    return (
        <div
          onClick={() => onClickOption(option)}
          className={
            searchOptions.indexOf(option) > -1 ?
                baseClass + " " + selectedClass : baseClass}>
          {hideText ? '' : option === "Starred" ? <span>&#9734;</span> : option }
        </div>
    );
};

export default ExploreSearch;
